import { versionedComponent } from '@edreamsodigeo/frontend-core';

export const PRICE_FREEZE_DESKTOP = 'FAN_PLUS7920_D';
export const PRICE_FREEZE_MOBILE = 'FAN_PLUS7920_M';
export const PRIME_FREEZE_DESKTOP = 'FAN_PLUS9180_D';
export const PRIME_FREEZE_MOBILE = 'FAN_PLUS9180_M';
export const PRIME_FIRST_PHASE_2_MOBILE = 'FAN_PLUS9570';
export const PRIME_FIRST_PHASE_2_DESKTOP = 'FAN_PLUS9571';

//versioned components go here
export const priceFreezeDesktopVersionedComponent =
  versionedComponent(PRICE_FREEZE_DESKTOP);
export const priceFreezeMobileVersionedComponent =
  versionedComponent(PRICE_FREEZE_MOBILE);

export const primeFreezeVersionedComponentDesktop =
  versionedComponent(PRIME_FREEZE_DESKTOP);

export const primeFreezeVersionedComponentMobile =
  versionedComponent(PRIME_FREEZE_MOBILE);

export const aliases = [
  PRICE_FREEZE_DESKTOP,
  PRICE_FREEZE_MOBILE,
  PRIME_FREEZE_DESKTOP,
  PRIME_FREEZE_MOBILE,
  PRIME_FIRST_PHASE_2_MOBILE,
  PRIME_FIRST_PHASE_2_DESKTOP,
];
